import { useEffect, useState } from 'react'

const useOutOfPolicyModal = ({ orderOutOfPolicy }) => {
  const [showOutOfPolicyModal, setShowOutOfPolicyModal] = useState(false)

  useEffect(() => {
    setShowOutOfPolicyModal(orderOutOfPolicy)
  }, [orderOutOfPolicy])

  const openOutOfPolicyModal = () => {
    setShowOutOfPolicyModal(true)
  }
  const closeOutOfPolicyModal = () => {
    setShowOutOfPolicyModal(false)
  }

  return {
    showOutOfPolicyModal,
    openOutOfPolicyModal,
    closeOutOfPolicyModal,
  }
}
export default useOutOfPolicyModal
